import { render, staticRenderFns } from "./dictiona.vue?vue&type=template&id=120f6a31&scoped=true&"
import script from "./dictiona.vue?vue&type=script&lang=js&"
export * from "./dictiona.vue?vue&type=script&lang=js&"
import style0 from "./dictiona.vue?vue&type=style&index=0&id=120f6a31&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120f6a31",
  null
  
)

export default component.exports